module.exports = __webpack_public_path__ + "img/add_stock.2669b2ff.gif";